import styles from "../styles/PayWidget.module.css";

export const SubmitButton = ({ onClick, disabled, children, orderSumm }) => (
    <button 
    type="button" 
    className={styles.button} 
    disabled={disabled} 
    onClick={onClick}
>
    {children} {orderSumm ? (<span>{orderSumm/100} </span>) : ""}
</button>

);

export default SubmitButton;
